
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import Menu from "vue-material-design-icons/Menu";
import Download from "vue-material-design-icons/Download";
import Import from "vue-material-design-icons/Import";
import TableApp from "@/components/Table/Table2";
import Check from "vue-material-design-icons/CheckBold.vue";
import FilterFields from "@/components/FilterFields";
import { actionsStore } from "@/components/Table/actionsStore";
import swal from "sweetalert";

export default {
  name: "app-monitor",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  components: {
    TableApp,
    Menu,
    Check,
    FilterFields,
    Download,
    Import,
  },
  data() {
    return {
      actionsStore,
      allStatus: [],
      manifestoDataSelected: null,
      statusToManifest: null,
      manifestoJustify: "",
      chaveDeAcesso: null,
      fields: [
        {
          label: "Número",
          field: "numero",
          slot: true,
          sortable: true,
          width: "5%",
        },
        {
          label: "Fornecedor",
          field: "fornecedor",
          width: "20%",
          type: "text",
          slot: true,
          sortable: true,
        },
        {
          label: "Chave de Acesso",
          field: "chave_acesso",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Data Emissão",
          field: "data_emissao",
          type: "date",
          filterable: true,
          slot: true,
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Total NFe",
          field: "valor_total",
          slot: true,
          type: "number",
          width: "10%",
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Ações",
          width: "10%",
          field: "actions",
          sortable: false,
          slot: true,
        },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getInit() {
      const { data } = await this.$http.post("/manifesto/lista-status");
      this.allStatus = data;
    },
    async exportToCompra(id_manifesto) {
      try {
        const { data } = await this.$http.post("/manifesto/download-xml", {
          id_manifesto,
        });
      } catch (error) {
        console.log(error);
      }

      this.$router.push({
        name: "comprasNovo",
        params: {
          id_manifesto,
        },
      });
    },
    async downloadXML(id_manifesto) {
      swal({
        title: "Deseja realizar a visualização do xml?",
        text: "Aguarde, pois será gerado o xml automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        try {
          const { data } = await this.$http.post("/manifesto/download-xml", {
            id_manifesto,
          });
          window.open(data["manifesto-xml-url"], "_blank");
        } catch (error) {
          console.log(error);
        }
        swal.stopLoading();
        swal.close();
      });
    },
    async manitorarByChave() {
      this.addLoadingToButton("monitorar_ByChave");

      if (!this.chaveDeAcesso) {
        this.removeLoadingToButton("monitorar_ByChave");

        this.$toast.warning("Informe a chave de acesso!");
        return;
      }

      try {
        await this.$http.post("/manifesto/inserir-chave", {
          chave: this.chaveDeAcesso,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$refs.monitorNfe.refresh();
        this.chaveDeAcesso = null;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("monitorar_ByChave");
      this.$bvModal.hide("monitorarByChaveModal");
    },
    async manifestar() {
      this.addLoadingToButton("consultar_manifestos");
      try {
        const response = await this.$http.post("/manifesto/consultar", undefined, {
          validateStatus: status =>
            (status >= 200 && status < 300) || status === 409,
        });

        if (response.status === 409) {
          if (response.data?.code === "NSU_SEQUENCE_INCORRECT") {
            this.$toast.warning(
              "<strong>Sequência NSU incorreta</strong><br>" +
                "A sequência de NSU está incorreta. Verifique se houve consulta por outra plataforma ou pela contabilidade e tente novamente."
            );
          } else {
            this.$toast.error(
              response.data?.msg ||
                response.data?.message ||
                "Não foi possível consultar os manifestos."
            );
          }
        } else {
          this.actionsStore.updateTable = !this.actionsStore.updateTable;
          this.$refs.monitorNfe.refresh();
        }
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("consultar_manifestos");
      this.$bvModal.hide("monitorarModal");
    },
    async manifestarNfe() {
      try {
        if (!this.statusToManifest) {
          this.$toast.error("Selecione o status para manifestar!");
          return;
        }
        if (this.statusToManifest === 6 && this.manifestoJustify.length < 15) {
          this.$toast.error("Mínimo de 15 caracteres na justificativa!");
          return;
        }
        this.addLoadingToButton("manifestar_nfe_button");
        await this.$http.post("/manifesto/manifestar-nfe", {
          id_manifesto: this.manifestoDataSelected.id_manifesto,
          status: this.statusToManifest,
          ...(this.manifestoJustify && {
            jusitifcativa: this.manifestoJustify,
          }),
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Nota manifestada com sucesso!");
        this.$refs.monitorNfe.refresh();
      } catch (error) {
        console.log(error);
        this.removeLoadingToButton("manifestar_nfe_button");
      }
      this.$bvModal.hide("manifestarNfe");
      this.removeLoadingToButton("manifestar_nfe_button");
    },
    selectManifestarNfe(nfeManifestoData) {
      this.manifestoDataSelected = nfeManifestoData;
      this.$bvModal.show("manifestarNfe");
    },
    isXmlImportadoEntrada(rowData) {
      return Boolean(rowData?.compra_id);
    },
    getXmlImportadoEntradaTooltip(rowData) {
      if (!rowData?.compra_importada_em) {
        return "Nota importada como compra";
      }

      return `Importada em ${this.formatDate(
        rowData.compra_importada_em,
        "DD/MM/YYYY"
      )}`;
    },
  },
  mounted() {
    this.getInit();
  },
  created() {},
};
